export default __webpack_public_path__ + "images/3M.bea6d62.png";